// extracted by mini-css-extract-plugin
module.exports = {"demoWrapper":"G73XqIFa1nFonDoRzFm55"};